// src/belediye/components/mesajlasma/varsayilanMerkez.js
// FAZ-55/17 — HARİTANIN AÇILIŞ NOKTASI, DASHBOARD İLE AYNI KAYNAKTAN.
//
// Kullanıcı (2026-07-28): "haritanın ilk açıldığı yer olarak sistemdeki BM4
// sınır yapısı var ya… ana sayfanın dashboard'undaki haritanın da beslendiği
// kaynaktan alalım. Harita herhangi bir yerde açılmasın, Arsuz'tan açılsın.
// Sonra 'konumumu bul' deyince oraya gitsin."
//
// Kaynak: GET /bm4/boundaries/default/ (DashboardLeafletMap'in kullandığı uç).
// Sonuç MODÜL DÜZEYİNDE tek sefer çözülür — görev sihirbazı her açıldığında
// ağ isteği atılmasın. Uç yoksa/yetki yoksa/patlarsa sessizce YEDEK merkeze
// düşer: harita açılmamazlık etmez (görev oluşturmayı bir config isteği
// engellememeli).
import { fetchBm4BoundaryDefaultConfigQuiet } from "../../services/dashboardApi";

// Arsuz ilçe merkezi — uç erişilemezse kullanılan yedek.
export const YEDEK_MERKEZ = [36.4083, 35.8878];
export const YEDEK_ZOOM = 13;

// DashboardLeafletMap.normalizeCenter ile AYNI kabuller: dizi [lat,lng] ya da
// {lat|latitude|center_lat|enlem, lng|longitude|center_lng|boylam|lon}.
export const merkeziNormalize = (raw) => {
  if (!raw) return null;
  if (Array.isArray(raw) && raw.length >= 2) {
    const lat = Number(raw[0]);
    const lng = Number(raw[1]);
    return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
  }
  if (typeof raw === "object") {
    const lat = Number(raw.lat ?? raw.latitude ?? raw.center_lat ?? raw.enlem);
    const lng = Number(raw.lng ?? raw.longitude ?? raw.center_lng ?? raw.boylam ?? raw.lon);
    return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
  }
  return null;
};

const zoomuNormalize = (raw) => {
  const z = Number(raw);
  return Number.isFinite(z) && z >= 3 && z <= 20 ? z : YEDEK_ZOOM;
};

let sozu = null;

export function varsayilanHaritaMerkezi() {
  if (sozu) return sozu;
  sozu = fetchBm4BoundaryDefaultConfigQuiet()
    .then((cfg) => ({
      merkez: merkeziNormalize(cfg?.center || cfg) || YEDEK_MERKEZ,
      zoom: zoomuNormalize(cfg?.zoom_level ?? cfg?.zoom),
    }))
    .catch(() => ({ merkez: YEDEK_MERKEZ, zoom: YEDEK_ZOOM }));
  return sozu;
}

// Testler için — modül düzeyindeki önbelleği sıfırlar.
export function _merkeziUnut() {
  sozu = null;
}
